var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { attrs: { "data-testid": "sensor-last-reception" } },
    [
      _vm._v(_vm._s(_vm.receivedAt)),
      _vm.signalStrength
        ? [
            _vm._v(_vm._s(_vm.$t("paren.open"))),
            _c("signal-strength-indicator", {
              attrs: { "signal-strength": _vm.signalStrength, size: "16" },
            }),
            _vm._v(_vm._s(_vm.$t("paren.close"))),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }